import { render } from "./Live.vue?vue&type=template&id=49088a5c"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import "./Live.vue?vue&type=style&index=0&id=49088a5c&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2024/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__